import { render, staticRenderFns } from "./LoginMaster.vue?vue&type=template&id=c56bf296&scoped=true&"
import script from "./LoginMaster.vue?vue&type=script&lang=js&"
export * from "./LoginMaster.vue?vue&type=script&lang=js&"
import style0 from "./LoginMaster.vue?vue&type=style&index=0&id=c56bf296&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56bf296",
  null
  
)

export default component.exports